import { Link } from "react-router-dom";
import { Award } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DOCTOR_NAME } from "@/lib/constants";
import doctorImg from "@/assets/doctor/doctor-hero-clinic.jpg";

const DoctorBlock = () => (
  <section className="py-14 md:py-20">
    <div className="container max-w-5xl">
      <div className="grid md:grid-cols-[260px_1fr] gap-8 items-center bg-card rounded-2xl border border-border p-6 md:p-10 shadow-sm">
        <div className="aspect-square rounded-xl overflow-hidden bg-muted">
          <img src={doctorImg} alt={`${DOCTOR_NAME} — Dental Surgeon, Kalyan`} className="w-full h-full object-cover" loading="lazy" />
        </div>
        <div>
          <span className="text-eyebrow text-primary">Meet Your Dentist</span>
          <h2 className="font-heading text-2xl md:text-3xl font-light mt-2 mb-3">{DOCTOR_NAME}</h2>
          <p className="text-sm text-muted-foreground mb-2 inline-flex items-center gap-2">
            <Award className="h-4 w-4 text-gold" />
            BDS, MDS · 15+ Years Experience · Certified Invisalign Provider
          </p>
          <p className="text-muted-foreground leading-relaxed mb-5">
            Dr. Khushboo Mutha leads Mutha's Advanced Dental Care with a patient-first philosophy, combining advanced training in
            cosmetic and restorative dentistry with the latest technology — iTero scanners, digital smile design
            and minimally invasive techniques. She has personally treated more than 10,000 patients across
            Kalyan, Dombivli and Ambernath.
          </p>
          <Button asChild variant="outline">
            <Link to="/our-doctors">View Doctor Profiles</Link>
          </Button>
        </div>
      </div>
    </div>
  </section>
);

export default DoctorBlock;